import client from "../api/client";

export const getList = () => {
  return client('/api/internal-values').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/internal-values/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/internal-values/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/internal-values', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/internal-values/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useInternalValueService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel
  };
}
